<script>
	export let src;
	export let userName;
	export let size;
	export let profilePictureBorderColor;
	import { ProfilePicture } from 'da-components';
	$: borderStyleString = profilePictureBorderColor && `border : 3px solid ${profilePictureBorderColor}`;
</script>

<div class="border mr" style={borderStyleString}>
	<ProfilePicture {src} {userName} {size} fontSize={size / 2} />
</div>

<style>
	.border {
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.mr {
		margin-right: 5px;
	}
</style>
